type ConnectWalletProps = {
  setLoginModalOpen: (value: boolean) => void;
};

export const ConnectWallet: React.FC<ConnectWalletProps> = ({
  setLoginModalOpen,
}) => {
  return <div className="connect-wallet">Connect Wallet to View Profile</div>;
};
